export enum Filter {
  ALL = 'all',
  LEAGUE = 'league',
  BUDGET = 'budget',
}
